import Chip from '@mui/material/Chip';

const statusStyles = {
  Published: {
    bg: '#F0FDF4',
    color: '#166534',
    border: '#BBF7D0',
  },
  Draft: {
    bg: '#F1F5F9',
    color: '#475569',
    border: '#CBD5E1',
  },
};

const StatusBadge = ({ status }) => {
  const style = statusStyles[status] || statusStyles.Draft;

  return (
    <Chip
      label={status}
      size="small"
      sx={{
        backgroundColor: style.bg,
        color: style.color,
        border: `1px solid ${style.border}`,
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: '6px',
        px: 0.5,
        height: '24px',
      }}
    />
  );
};

export default StatusBadge;